module.exports = __webpack_public_path__ + "img/case_360.96a05575.png";